<template>
  <div class="store">
    <el-row class="cover-store"><el-button type="primary" size="mini" @click="onShowCoveStore">店铺补位设置</el-button></el-row>
    <el-table :data="storeData" highlight-current-row style="width: 100%">
      <!-- <el-table-column type="index" label="序号" width="80" align="center" /> -->
      <el-table-column type="sort" label="序号" width="80" align="center" >
        <template slot-scope="scope">
          <div class="merchant-name">
            <span class="name">{{ scope.row.sort }}</span>
            <span v-if="scope.row.id">
              <i
                class="el-icon-edit"
                style="margin-left: 10px"
                @click="handleClickSort(scope.row)"
              ></i> 
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="商户名称" align="center" width="400">
        <template slot-scope="scope">
          <div class="merchant-name">
            <p class="name">{{ scope.row.merchantName }}</p>
            <div>
              <i
                class="el-icon-edit"
                style="margin-right: 10px"
                @click="handleClick(scope.row)"
              ></i>
              <i
                v-if="scope.row.merchantName"
                class="el-icon-delete"
                @click="onDelete(scope.row)"
              ></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺名" align="center" />
      <el-table-column label="店铺logo" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.shopLogo"
            :src="scope.row.shopLogo"
            alt=""
            style="width: 60px; height: 60px"
          />
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增/编辑 -->
    <el-dialog title="选择推荐店铺" :visible.sync="dialogVisible" width="450px" @close="onClose">
      <ShopAutocomplete ref="shopRef" @handleSelect="handleSelect" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
     <!-- 补位店铺设置 -->
    <el-dialog title="店铺补位设置" :visible.sync="showCoveStore" width="70%" @close="onCloseCoveStore">
         <StoreCoverSetting :visible.sync="showCoveStore"  @refreshList="getStoreList"/>
      <span slot="footer" class="dialog-footer">
       <el-button size="small" @click="onCloseCoveStore">取消</el-button>
        <!-- <el-button size="small" type="primary" @click="onSubmit"
          >确认</el-button
        > -->
      </span>
    </el-dialog>
    <setSort ref="setSort"  @refreshList="getStoreList" :appendToBody="true"/>
  </div>
</template>

<script>
import {
  getRecommendShopList,
  addRecommendShop,
  updateRecommendShop,
  deleteRecommendShop,
} from "@/api/recommendationHome";
import ShopAutocomplete from "../components/shopAutocomplete"
import StoreCoverSetting from "../components/storeCoverSetting";
import setSort from "../components/setSort";
export default {
  props: {},
  components: { ShopAutocomplete , StoreCoverSetting,setSort},
  data() {
    return {
      dialogVisible: false,
      storeData: [],
      tableData: [],
      currentInfo: {},
      showCoveStore: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getStoreList();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    handleClickSort(row) {
      this.$refs.setSort.show(row,'shop');
    },
    getStoreList() {
      getRecommendShopList().then((res) => {
        if (res.code == 0) {
          const responseData = res.data;
          // 判断数据数量是否不足 6 条
          if (responseData.length < 6) {
            const remainingCount = 6 - responseData.length;
            const remainingData = Array.from(
              { length: remainingCount },
              () => ({})
            );
            responseData.push(...remainingData);
          }
          // 使用补齐后的数据
          this.storeData = responseData;
        }
      });
    },
    handleSelect (row) {
      this.tableData = [];
      this.currentInfo.shopId = row.id;
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.currentInfo = row;
    },
    // 新增推荐商铺信息
    onAdd(shopId) {
      addRecommendShop({ shopId: shopId }).then((res) => {
        if (res.code === 0) {
          this.$message.success("操作成功");
          this.getStoreList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 编辑推荐商铺信息
    onEdit(row) {
      updateRecommendShop({ shopId: row.shopId, id: row.id }).then((res) => {
        if (res.code === 0) {
          this.$message.success("操作成功");
          this.getStoreList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    onDelete(row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteRecommendShop(row.id);
        })
        .then(() => {
          this.getStoreList();
          this.$message.success("删除成功");
        });
    },
    /** 店铺补位设置*/
    onShowCoveStore() {
      this.showCoveStore = true
    },
    /** 店铺补位设置*/
    onCloseCoveStore() {
      this.showCoveStore = false
    },
    onSubmit() {
      this.dialogVisible = false;
      const { currentInfo } = this;
      if (currentInfo.id) {
        this.onEdit(currentInfo);
        return;
      }
      this.onAdd(currentInfo.shopId);
    },

    onClose() {
      this.dialogVisible = false;
      this.$refs.shopRef.params.keyWords = ""
    }
  },
};
</script>
<style lang="scss" scoped>
.merchant-name {
  display: flex;
  align-items: center;
  justify-content: center;
  .name {
    flex: 1;
  }
}
.cover-store {
  margin: 10px;
}
.cover-page {
  &-head {
    display: flex;
    margin-bottom: 15px;
    .search-input {
      width: 200px;
      margin-right: 10px;
    }
  }
}
</style>
